const scmpDataConverter = ({ styleSettings, selectedNews, newsList }) => {
  return {
    slideItems: selectedNews.map((newsId) => {
      const news = newsList.find((news) => news.id === newsId);
      return {
        title: {
          text: news.title ?? "",
          color: styleSettings?.slideItem?.title?.color ?? undefined, // optional
          backgroundColor: styleSettings?.slideItem?.title?.backgroundColor ?? undefined, // optional
        },
        category: {
          text: (news.category ?? "").slice(0, 25), // max 25
          color: styleSettings?.slideItem?.category?.color ?? "",
          backgroundColor: styleSettings?.slideItem?.category?.backgroundColor ?? "",
        },
        voiceText: (news.voiceText ?? ""),
        imageUrl: (news.image ?? ""),
      };
    }),
  };
};

const SCMP_DEFAULT_STYLE_SETTINGS = {
  slideItem: {
    title: {
      color: "#000000",
      backgroundColor: "#ffffff",
    },
    category: {
      color: "#000000",
      backgroundColor: "#ffffff",
    },
  },
};

export { scmpDataConverter, SCMP_DEFAULT_STYLE_SETTINGS };
